<template>
  <div class="p-6">

    <h1 class="text-2xl font-medium text-gray-800 mb-8">
      Email Notification Settings
    </h1>


    <!-- info -->
    <div class="flex items-start gap-3 p-4 bg-white border border-orange-200 rounded-lg mb-8">
      <component :is="Info" class="w-6 h-6 text-primary"/>
      <p class="text-gray-600 text-sm">
        Control which email notifications you want to receive for account
        transactions.
      </p>
    </div>


    <!-- steps -->
    <div class="flex md:flex-row md:justify-between md:items-center md:border-b md:border-gray-200 mb-8 flex-col gap-5">

      <div class="flex items-center">
        <div :class="stepClass(1)">1</div>
        <span class="ml-2">Fill Data</span>
      </div>

      <div class="flex items-center">
        <div :class="stepClass(2)">2</div>
        <span class="ml-2">Confirm Changes</span>
      </div>

      <div class="flex items-center">
        <div :class="stepClass(3)">3</div>
        <span class="ml-2">Confirmation</span>
      </div>

    </div>


    <!-- STEP 1 -->
    <div v-if="step === 1" class="space-y-6">

      <div class="bg-white border rounded-lg p-6 space-y-4">

        <h3 class="font-semibold text-gray-800">
          Email Notifications
        </h3>

        <label class="flex items-center justify-between border p-4 rounded-lg cursor-pointer">

          <div>
            <p class="font-medium text-gray-700">Incoming Transfers</p>
            <p class="text-sm text-gray-500">
              Receive email when money is credited to your account
            </p>
          </div>

          <input type="checkbox" v-model="incoming" class="w-5 h-5">

        </label>


        <label class="flex items-center justify-between border p-4 rounded-lg cursor-pointer">

          <div>
            <p class="font-medium text-gray-700">Outgoing Transfers</p>
            <p class="text-sm text-gray-500">
              Receive email when money is debited from your account
            </p>
          </div>

          <input type="checkbox" v-model="outgoing" class="w-5 h-5">

        </label>

      </div>


      <div class="flex justify-center mt-6">

        <button
            @click="goToConfirm"
            class="bg-primary text-white font-medium py-3 px-12 rounded-lg">

          Continue

        </button>

      </div>

    </div>



    <!-- STEP 2 -->
    <div v-if="step === 2" class="bg-white border rounded-lg p-6">

      <h3 class="font-semibold text-gray-800 mb-6">
        Confirm Notification Preferences
      </h3>

      <div class="space-y-4 text-sm">

        <div class="flex justify-between">
          <span>Incoming Transfers</span>
          <span class="font-medium">
{{ incoming ? 'Enabled' : 'Disabled' }}
</span>
        </div>

        <div class="flex justify-between">
          <span>Outgoing Transfers</span>
          <span class="font-medium">
{{ outgoing ? 'Enabled' : 'Disabled' }}
</span>
        </div>

      </div>


      <div class="flex justify-between mt-8">

        <button
            @click="step = 1"
            class="px-6 py-3 border rounded">

          Back

        </button>

        <button
            @click="saveSettings"
            :disabled="loading"
            class="px-6 py-3 bg-primary text-white rounded">

          {{ loading ? 'Saving...' : 'Save Settings' }}

        </button>

      </div>

    </div>



    <!-- STEP 3 -->
    <div v-if="step === 3" class="text-center py-10">

      <h3 class="text-xl font-semibold mb-3 text-green-600">
        Settings Updated
      </h3>

      <p class="text-gray-600">
        Your email notification preferences have been updated successfully.
      </p>

    </div>

  </div>
</template>



<script setup>

import {ref,onMounted} from "vue"
import {Info} from "lucide-vue-next"
import api from "@/services/api"


const step = ref(1)

const incoming = ref(true)
const outgoing = ref(true)

const loading = ref(false)


const stepClass = (num)=>{
  return [
    "w-8 h-8 flex items-center justify-center rounded-full font-bold",
    step.value === num
        ? "bg-gray-800 text-white"
        : "bg-gray-200 text-gray-700"
  ]
}


const goToConfirm = ()=>{
  step.value = 2
}



const loadSettings = async ()=>{

  try{

    const res = await api.get("/notification-settings",{
      headers:{Authorization:`Bearer ${localStorage.getItem('token')}`}
    })

    incoming.value = res.data.incoming
    outgoing.value = res.data.outgoing

  }catch(e){

    console.error(e)

  }

}


const saveSettings = async ()=>{

  loading.value = true

  try{

    await api.post("/notification-settings",{

      incoming: incoming.value,
      outgoing: outgoing.value

    },{
      headers:{Authorization:`Bearer ${localStorage.getItem('token')}`}
    })

    step.value = 3

  }catch(e){

    alert("Error saving settings")

  }finally{

    loading.value = false

  }

}



onMounted(()=>{
  loadSettings()
})

</script>